/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseShiftsResponse } from '../../models/base-shifts-response';

export interface ListBaseShifts$Params {
}

export function listBaseShifts(http: HttpClient, rootUrl: string, params?: ListBaseShifts$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseShiftsResponse>> {
  const rb = new RequestBuilder(rootUrl, listBaseShifts.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseShiftsResponse>;
    })
  );
}

listBaseShifts.PATH = '/api/scheduler/bases/shifts';
